import { render, staticRenderFns } from "./PendingBusiness.vue?vue&type=template&id=2a86981c&scoped=true&"
import script from "./PendingBusiness.vue?vue&type=script&lang=ts&"
export * from "./PendingBusiness.vue?vue&type=script&lang=ts&"
import style0 from "./PendingBusiness.vue?vue&type=style&index=0&id=2a86981c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a86981c",
  null
  
)

export default component.exports